import { useCart } from '@shared/cart-react';
import { useEffect } from 'react';

// Listens to the the custom Klaviyo Form event
// https://developers.klaviyo.com/en/docs/track_klaviyo_form_activity_using_javascript
const useTrackKlaviyoFormEvent = () => {
  const cart = useCart();

  useEffect(() => {
    const klaviyoFormEventHandler: EventListener = (e: Event) => {
      const { detail } = e as any as KlaviyoFormEvent;
      const eventType = detail.type;
      const metaData = detail.metaData;

      if (eventType === 'submit' || eventType === 'stepSubmit') {
        if (!metaData) return;
        const { $email, $phone_number } = metaData;
        const customerInfo: { email?: string; phone?: string } = {};

        if ($email) {
          customerInfo.email = $email;
        }
        if ($phone_number) {
          customerInfo.phone = $phone_number;
        }

        // Save customer info from Klaviyo form to cart
        cart.updateCustomer(customerInfo);
      }
    };

    window.addEventListener('klaviyoForms', klaviyoFormEventHandler);

    return () => {
      window.removeEventListener('klaviyoForms', klaviyoFormEventHandler);
    };
  }, [cart]);

  return null;
};

export default useTrackKlaviyoFormEvent;

type SubmitDetailType = {
  type: 'stepSubmit' | 'submit';
  formId: string;
  companyId: string;
  metaData: {
    // This object will include any of the fields in the Klaviyo form.
    // Those fields will most often only be email and/or phone number
    $email?: string;
    $phone_number?: string;

    // Other Klaviyo metadata
    $consent_form_id: string;
    $consent_form_version: number;
    $consent_method: string;
    $source: string;
    $step_name: string;
    sentIdentifiers: {};
    sms_consent: boolean;
  };
};

type RegularDetailType = {
  type: 'open' | 'embedOpen' | 'close' | 'redirectedToUrl' | 'viewedStep';
  formId: string;
  companyId: string;
  metaData: undefined;
};

type KlaviyoFormEvent = {
  detail: RegularDetailType | SubmitDetailType;
};
